import request from "@/utils/request";

export const listProjectAlarmPromise = (p) => request({
  url: "/admin/project/alarm/list",
  method: "post",
  data: p
});

export const addProjectAlarmPromise = (p) => request({
  url: "/admin/project/alarm/add",
  method: "post",
  data: p
});

export const updateProjectAlarmPromise = (p) => request({
  url: "/admin/project/alarm/update",
  method: "post",
  data: p
});

export const deleteProjectAlarmPromise = (p) => request({
  url: "/admin/project/alarm/delete",
  method: "post",
  data: p
});
